import { render, staticRenderFns } from "./EditOrg.vue?vue&type=template&id=3e33ae8a&scoped=true&"
import script from "./EditOrg.vue?vue&type=script&lang=js&"
export * from "./EditOrg.vue?vue&type=script&lang=js&"
import style0 from "./EditOrg.vue?vue&type=style&index=0&id=3e33ae8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e33ae8a",
  null
  
)

export default component.exports